// extracted by mini-css-extract-plugin
module.exports = {"about":"about_about__3s839","title":"about_title__14u4U","section":"about_section__2DrW9","text":"about_text__2fSv6","image":"about_image__26jku"};